import React, { Component } from 'react';
import Tabs from 'muicss/lib/react/tabs';
import Tab from 'muicss/lib/react/tab';
import Card_Custom from '../components/card';
import $ from 'jquery';

export default class RenderPopularBoxInfo extends Component{
	checkDefaultIndex(data) {
		const source = ['FB','YT','IG']
		let hotPostTabIndex

		source.some((item,index) => {
			if(data[item].length){
				hotPostTabIndex = index
				return true
			}
		})

		return hotPostTabIndex
	}

	componentDidMount() {
		const hotPostData = this.props.postlist.data.hot_post
		const source = {
			'FB':1,
			'YT':2,
			'IG':3,
		}

		Object.keys(hotPostData).forEach((item,index) => {
			let hideTabIndex

			if(!hotPostData[item].length) {
				hideTabIndex = source[item]
				$('.hotpostTab .mui-tabs__bar li:nth-child(' + hideTabIndex + ')').hide()
			}
		})
	}

	render() {
		const postlist = this.props.postlist
		const popularGroup = []
	    const sourceLabelArr  = ['Facebook 近半年貼文','Youtube 近半年貼文','Instagram 近半年貼文']
	    const source = ['FB','YT','IG']

	    source.forEach((item,index) => {
    	    popularGroup.push(
    	    	<Tab value={`pane-${index}`} label={sourceLabelArr[index]} key={index}>
	    	    	<div className="keywordSection">
	    	    		<Card_Custom cardinfo={postlist.data.hot_post[item]} showSourceIcon={false}/>
	    	    	</div>
    	    	</Tab>
    	    )
	    })

	  	return (
	  		<div>
	  			<Tabs onChange={this.onChange} defaultSelectedIndex={this.checkDefaultIndex(postlist.data.hot_post)} className="profileTabWrap hotpostTab">
	  				{popularGroup}
	  			</Tabs>
	  		</div>
	    )
  	}
}



// WEBPACK FOOTER //
// ./src/components/renderPopularBoxInfo.js